import PropTypes from 'prop-types';

function CheckoutTaxStatus({ paused = false, taxQuote = null }) {
  if (paused) {
    return null;
  }

  return (
    <div className="text-gray-600 text-xs" aria-live="polite" role="status">
      {taxQuote?.status === 'calculating' ? (
        <p>
          {taxQuote?.capability?.enabled === false
            ? 'Updating checkout totals…'
            : 'Calculating tax…'}
        </p>
      ) : null}
      {taxQuote?.status === 'error' ? (
        <div className="text-red-700" role="alert">
          {(taxQuote.errors || []).map((quoteError) => (
            <p key={`${quoteError.path}-${quoteError.message}`}>
              {quoteError.message}
            </p>
          ))}
          <button
            type="button"
            className="mt-2 font-medium text-rcprimary-500 underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-rcprimary-500 focus-visible:outline-offset-2"
            onClick={taxQuote.refresh}
          >
            {taxQuote?.capability?.enabled === false
              ? 'Retry checkout totals'
              : 'Retry tax calculation'}
          </button>
        </div>
      ) : null}
      {!taxQuote?.capability && taxQuote?.status !== 'error' ? (
        <p>Checking tax availability&hellip;</p>
      ) : null}
      {taxQuote?.capability?.enabled && taxQuote.status === 'idle' ? (
        <p>Enter a complete shipping address to calculate tax.</p>
      ) : null}
    </div>
  );
}

CheckoutTaxStatus.propTypes = {
  paused: PropTypes.bool,
  taxQuote: PropTypes.shape({
    capability: PropTypes.shape({
      enabled: PropTypes.bool.isRequired,
    }),
    errors: PropTypes.arrayOf(
      PropTypes.shape({
        message: PropTypes.string.isRequired,
        path: PropTypes.string,
      }),
    ),
    refresh: PropTypes.func.isRequired,
    status: PropTypes.string,
  }),
};

export default CheckoutTaxStatus;
